import React, { Component, Fragment } from "react";

import Loader from "../../components/Loader/Loader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";



import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import CardContent from "../../components/Card/CardContent/CardContent";
import Section from "../../components/Section/Section";
import Summary from "../../components/Summery/Summary";
import CategoryForm from "../../components/CategoryForm/CategoryForm";
import CUDButtons from "../../components/CUDButtons/CUDButtons";
import MessageHandler from "../../components/MessageHandler/MessageHandler";

import "./Category.css";

class Category extends Component {
  state = {
    isEditing: false,
    categories: [],
    summeries: [],
    isChildSummerySelected: false, 
    categoriesLoading: true,
    parentCode: {},
    categoryFormLoading: false,
    functionButtonsLoading: false,
    functionButtonsEditable: false,
    error: null,
    showMessage: "",
    deleteCategoryTitle: "",
  };

  componentDidMount() {
    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
        });
      })
      .catch(this.catchError);
  }

  newResetHandler = () => {
    this.setState({
      categories: [],
      categoriesLoading: false,
      summeries: [],
      isChildSummerySelected: false,
    });

    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
          categoryFormLoading: false,
          functionButtonsLoading: false,
          functionButtonsEditable: false,
          isEditing: false,
        });
      })
      .catch(this.catchError);
  };

  addCategoryParentHandler = () => {
    var parentCode = {};
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        } else {
          this.state.categories[i][index].name ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentCode = this.state.categories[i][index]);
        }
      }
    }
    this.setState({
      parentCode: parentCode,
      functionButtonsLoading: true,
    });
    if (Object.keys(parentCode).length !== 0) {
      this.setState({
        functionButtonsEditable: true,
      });
    }
  };
  onAddHandler = () => {
    this.setState({
      categoryFormLoading: true,
      isEditing: false,
    });
  };
  onEditHandler = () => {
    this.setState({
      categoryFormLoading: true,
      isEditing: true,
    });
  };

  onDeleteHandler = () => {
    var deleteCategoryTitle = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (deleteCategoryTitle = this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")");
        }else{
          this.state.categories[i][index].name ===
            (this.state.summeries[this.state.summeries.length - 1] ) && (deleteCategoryTitle = this.state.categories[i][index].name);
        }
      }
    }

    this.setState({
      deleteCategoryTitle: deleteCategoryTitle, 
      showMessage: true,
    });
  };

  onCancelHandler = () => {
    this.setState({
      deleteCategoryTitle: "",
      showMessage: false,
    });
  };

  onDeleteCategoryHandler = () => {
    this.setState({ categoriesLoading: true });
    
    var categoryCode = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (categoryCode = this.state.categories[i][index].code);
        }else{
          this.state.categories[i][index].name ===
            (this.state.summeries[this.state.summeries.length - 1] ) && (categoryCode = this.state.categories[i][index].code);
        }
      }
    }
    
    const graphqlQuery = {
      query: `
        mutation {
          deleteCategory(code: ${parseInt(categoryCode)})
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("خطا در حذف گروه کالایی!");
        }
        this.setState({
          showMessage: false,
          deleteCategoryTitle: ""
        });
        this.newResetHandler();
        // this.setState(prevState => {
        //   const updatedPosts = prevState.posts.filter(p => p.id !== postId);
        //   return { posts: updatedPosts, categoriesLoading: false };
        // });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ categoriesLoading: false,  showMessage: false, deleteCategoryTitle: ""});
      });
  };

  onSelectHandler = (parentCode) => {
    var indexOfParent = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        this.state.categories[i][index].code === parentCode.code &&
          (indexOfParent = i);
      }
    }
    this.setState({
      categories: this.state.categories.slice(0, indexOfParent + 1),
      summeries: this.state.summeries.splice(
        indexOfParent,
        this.state.summeries.length
      ),
      categoryFormLoading: false,
      functionButtonsLoading: false,
      functionButtonsEditable: false,
    });

    var summeryName = "";
    var isChildSummerySelected = false;
    for (var j = 0; j < this.state.categories.length; j += 1) {
      for (let index = 0; index < this.state.categories[j].length; index++) {
        if (this.state.categories[j][index].code === parentCode.code) {
          summeryName = this.state.categories[j][index].name;
          if (this.state.categories[j][index].secondName) {
            summeryName =
              summeryName +
              " (" +
              this.state.categories[j][index].secondName +
              ")";
          }
          if (!this.state.categories[j][index].hasChildren) {
            isChildSummerySelected = true;
          }
        }
      }
    }

    if (summeryName !== "") {
      var joined = this.state.summeries.concat(summeryName);
      this.setState({
        summeries: joined,
        isChildSummerySelected: isChildSummerySelected,
      });
    }

    const graphqlQuery = {
      query: `
        query FetchSubCategories($parentCode: Int) {
          subCategories(parentCode: $parentCode){
            code  
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
      variables: {
        parentCode: parentCode.code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }

        if (resData.data.subCategories.length) {
          var flag = false;
          for (var i = 0; i < this.state.categories.length; i += 1) {
            flag =
              this.state.categories[i][0].code ===
              resData.data.subCategories.code
                ? true
                : false;
          }
          if (!flag) {
            this.setState({
              categories: [
                ...this.state.categories,
                resData.data.subCategories,
              ],
              categoriesLoading: false,
            });
          }
        }
      })
      .catch(this.catchError);
  };

  ////////////////////////////////////////////////////////////////////////////////
  createCategoryHandler = (event, categoryData) => {
    event.preventDefault();
    this.setState({ categoriesLoading: true });
    let graphqlQuery;
    if (this.state.isEditing) {
      graphqlQuery = {
        query: `
        mutation UpdateExistingCategory($code: Int!, $name: String!, $secondName: String, $enName: String!, $dataTheme: Int!, $isUniformPackaging: Boolean!, $isActive: Boolean!, $displayOrder: String!, $parentCode: Int!){
            updateCategory(code: $code, categoryInput: {name: $name, secondName: $secondName, enName: $enName, dataTheme: $dataTheme, isUniformPackaging: $isUniformPackaging, isActive: $isActive, displayOrder: $displayOrder, parentCode: $parentCode}) {
              code
              name 
              secondName
              enName
              dataTheme
              isUniformPackaging
              hasChildren
              displayOrder
            }
          }
      `,
        variables: {
          code: this.state.parentCode.code,
          name: categoryData.categoryForm.name.value,
          secondName: categoryData.categoryForm.secondName.value,
          enName: categoryData.categoryForm.enName.value,
          dataTheme: parseInt(categoryData.categoryForm.dataTheme.value.value),
          isActive: categoryData.isActive,
          isUniformPackaging:
            categoryData.categoryForm.isUniformPackaging.value.value === "1"
              ? true
              : false,
          displayOrder: categoryData.displayOrder.toString(),
          parentCode: categoryData.parentCode,
        },
      };
    }else{
      graphqlQuery = {
        query: `
        mutation CreateNewCategory($name: String!, $secondName: String, $enName: String!, $dataTheme: Int!, $isUniformPackaging: Boolean!, $isActive: Boolean!, $displayOrder: String!, $parentCode: Int!){
            createCategory(categoryInput: {name: $name, secondName: $secondName, enName: $enName, dataTheme: $dataTheme, isUniformPackaging: $isUniformPackaging, isActive: $isActive, displayOrder: $displayOrder, parentCode: $parentCode}) {
              id
              name
              enName
            }
          }
      `,
        variables: {
          name: categoryData.categoryForm.name.value,
          secondName: categoryData.categoryForm.secondName.value,
          enName: categoryData.categoryForm.enName.value,
          dataTheme: parseInt(categoryData.categoryForm.dataTheme.value.value),
          isUniformPackaging:
            categoryData.categoryForm.isUniformPackaging.value.value === "1"
              ? true
              : false,
          isActive: categoryData.isActive,
          displayOrder: categoryData.displayOrder.toString(),
          parentCode: categoryData.parentCode,
        },
      };     
    }
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors && resData.errors[0].status === 422) {
          throw new Error(
            "خطا در ذخیره اطلاعات!"
          );
        }
        if (resData.errors) {
          throw new Error("خطایی در ذخیره اطلاعات به وجود آمده!");
        }
        this.newResetHandler();
        //this.props.history.replace("/");
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          categoriesLoading: false,
          error: err,
        });
      });
  };

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelHandler}
          message={
            'آیا می‌خواهید گروه کالایی "' +
            this.state.deleteCategoryTitle +
            '" را پاک کنید؟'
          }
          onCancelModal={this.onCancelHandler}
          onAcceptModal={this.onDeleteCategoryHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />

        <Content>
          <ContentHeader
            headerAction="درج گروه کالایی"
            headerDescription="اطلاعات گروه‌های کالایی را در این صفحه وارد کنید"
          />
          <Card>
            <CardContent cardTitle="مدیریت گروه کالایی">
              <section className="feed">
                {this.state.categoriesLoading && (
                  <div style={{ textAlign: "center", marginTop: "2rem" }}>
                    <Loader />
                  </div>
                )}
                {this.state.categories.length <= 0 &&
                !this.state.categoriesLoading ? (
                  <p style={{ textAlign: "center" }}>گروه کالایی وجود ندارد.</p>
                ) : null}
                <div className="mn-content-categories" id="categoriesContainer">
                  <div className="mn-content-categories__container">
                    {!this.state.categoriesLoading &&
                      this.state.categories.map((category) => (
                        <Section
                          categories={category}
                          onSelect={this.onSelectHandler.bind(this)}
                        />
                      ))}
                  </div>
                  <div className="mn-content-categories__summary">
                    <Summary
                      noneable={true}
                      summeries={this.state.summeries}
                      isChildSummerySelected={this.state.isChildSummerySelected}
                      newResetHandler={this.newResetHandler.bind(this)}
                      addCategoryParentHandler={this.addCategoryParentHandler.bind(
                        this
                      )}
                      onAddHandler={this.onAddHandler.bind(this)}
                    />
                  </div>
                </div>
                <div>
                  {this.state.functionButtonsLoading && this.state.functionButtonsEditable &&(
                    <CUDButtons
                      categoryName={
                        this.state.summeries[this.state.summeries.length - 1]
                      } 
                      // editable={this.state.functionButtonsEditable}
                      onAddHandler={this.onAddHandler.bind(this)}
                      onEditHandler={this.onEditHandler.bind(this)}
                      onDeleteHandler={this.onDeleteHandler.bind(this)}
                    />
                  )}
                </div>
                {this.state.categoryFormLoading && (
                  <CategoryForm
                    parentCode={this.state.parentCode}
                    onCreateCategory={this.createCategoryHandler}
                    loading={this.state.authLoading}
                    isEditing={this.state.isEditing}
                  />
                )}
              </section>
            </CardContent>
          </Card>
        </Content>
      </Fragment>
    );
  }
}

export default Category;